import React from 'react';
import CasesIcon from '@mui/icons-material/ViewList';
import ValidIcon from '@mui/icons-material/Copyright';
import PaidIcon from '@mui/icons-material/Euro';
import ActiveIcon from '@mui/icons-material/Send';
import CanceledIcon from '@mui/icons-material/Close';
import StandbyIcon from '@mui/icons-material/Snooze';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Config = {
  CASES: {
    key: 'CASES',
    name: 'Cases',
    icon: <CasesIcon />,
  },
  STANDBY: {
    key: 'STANDBY',
    name: 'Standby',
    icon: <StandbyIcon />,
  },
  ACTIVE: {
    key: 'ACTIVE',
    name: 'Active',
    icon: <ActiveIcon />,
  },
  PAYMENT_PROCESSING: {
    key: 'PAYMENT_PROCESSING',
    name: 'Payment Processing',
    icon: <AccessTimeIcon />,
  },
  PAID: {
    key: 'PAID',
    name: 'Paid',
    icon: <PaidIcon />,
  },
  VALID_LICENSE: {
    key: 'VALID_LICENSE',
    name: 'Valid License',
    icon: <ValidIcon />,
  },
  CANCELLED: {
    key: 'CANCELLED',
    name: 'Cancelled',
    icon: <CanceledIcon />,
  },
};

export default Config;
